/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { reposCreate } from "../../funcs/reposCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateRepoRequest$inboundSchema,
};

export const tool$reposCreate: ToolDefinition<typeof args> = {
  name: "repos-create",
  description: `Create a repository

Provisions a repository (org owner/admin only): DB insert
(authoritative) → Gitea create (rolled back on failure). The repository
belongs to the caller's org.
`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await reposCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
